export default __webpack_public_path__ + "static/media/1501.09f5a281.png";